export const OfferStage = {
  QUOTATION: 'quotation',
  BOOKING: 'booking',
}

export const OfferQuotationStatus = {
  QUOTATION_DRAFT: 'Quotation Draft',
  QUOTATION_SUBMITTED: 'Pending Contributor Approval',
  QUOTATION_REVIEWED: 'Pending Approver Approval',
  QUOTATION_REJECTED: 'Approver Rejected',
  QUOTATION_APPROVED: 'Pending Upload',
  QUOTATION_COMPLETED: 'Submitted to Client',
}

export const OfferBookingStatus = {
  BOOKING_DRAFT: 'Booking Draft',
  BOOKING_SUBMITTED: 'Booking Submitted',
  BOOKING_REJECTED: 'Booking Rejected',
  BOOKING_COMPLETED: 'Booking Completed',
}

export const OfferControlStatus = {
  // LOST: 'Lost',
  // DELETED: 'Deleted',
  CLOSED: 'Closed',
  SUPERSEDED: 'Superseded',
  AWARDED: 'Awarded',
}
export const OfferStatus = {
  ...OfferQuotationStatus,
  ...OfferBookingStatus,
  ...OfferControlStatus,
}

export const ContributorStatus = {
  REQUIRED: 'Action Required',
  REVIEWED: 'Reviewed',
  COMMENTED: 'Commented',
}

export const ApprovalStatus = {
  UPCOMING: 'Upcoming',
  REQUIRED: 'Action Required',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
}

export const PRApprovalStatus = {
  ...ApprovalStatus,
  PARKED: 'On Hold',
}

export const ApprovalInvitationStatus = {
  INVITED: 'Invited',
  REPLIED: 'Replied',
  NOT_REQUIRED: 'Not Required',
}

export const BookingApproverRole = {
  TECHNICAL: 'technical',
  COMMERCIAL: 'commercial',
  LEGAL: 'legal',
  TECHNICAL_PROJECT_MANAGER: 'technicalProjectManager',
  COMMERCIAL_PROJECT_MANAGER: 'commercialProjectManager',
  QS: 'qs',
  OTHER: 'other',
}

export const RoleInOffer = {
  INITIATOR: 'Sales Responsible',
  DEPT_USER: 'Same Team User',
  CREATOR: 'Creator',
  CONTRIBUTOR_LEGAL: 'Contributor - Legal',
  CONTRIBUTOR_QS: 'Contributor - Quality Surveyor',
  CONTRIBUTOR_OTHER: 'Contributor',
  TECHNICAL_PROJECT_MANAGER: 'Contributor - Technical Project Manager',
  COMMERCIAL_PROJECT_MANAGER: 'Contributor - Commercial Project Manager',
  PROCUREMENT_OFFICER: 'Procurement Officer',
  OPTIONAL_CONTRIBUTOR: 'Optional Contributor',

  QUOTATION_APPROVER: 'Quotation Approver',
  QUOTATION_APPROVER_DELEGATEE: "Quotation Approver's Delegatee",
  QUOTATION_APPROVER_INVITEE: "Quotation Approver's Invitee",
  BOOKING_APPROVER: 'Booking Approver',
  BOOKING_COMMERCIAL_PROJECT_MANAGER: 'Booking Commercial Project Manager',
  BOOKING_APPROVER_DELEGATEE: "Booking Approver's Delegatee",
  BOOKING_APPROVER_INVITEE: "Booking Approver's Invitee",
  GCPR_APPROVER_INVITEE: "GCPR Approver's Invitee",
  TEAM_ASSISTANT: 'Team Assistant',
  ENGINEER: 'Engineer',
  MANAGER: 'Manager',
  BOOKING_MANAGER: 'Booking Manager',
  PR_APPROVER: 'PR Approver',
  GCPR_APPROVER: 'GCPR Approver',
}

export const OfferType = {
  MAINTENANCE: 'maintenance',
  PROJECT: 'project',
}

export const Currency = {
  HKD: 'HKD',
  MOP: 'MOP',
  USD: 'USD',
  EUR: 'EUR',
  CNY: 'CNY',
}

export const MaintenanceSummaryStatus = {
  NOT_STARTED: 'notStarted',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  RENEWAL_LOST: 'renewalLost',
  RENEWED: 'renewed',
  NOT_COMPLETED: 'notCompleted',
}

export const OfferPaymentCreditTerm = {
  A000: 'A000',
  A014: 'A014',
  A030: 'A030',
  A045: 'A045',
  A060: 'A060',
  A090: 'A090',
}

export const OfferApprovalType = {
  CONTRIBUTION_REVIEW: 'Review',
  OPTIONAL_CONTRIBUTION_REVIEW: 'Optional Contributor Review ',
  CONTRIBUTION_COMMENT: 'Comment',
  QUOTATION_APPROVE: 'Approve Quotation',
  QUOTATION_REJECT: 'Reject Quotation',
  QUOTATION_REPLY: 'Reply Quotation',
  BOOKING_APPROVE: 'Approve Booking',
  BOOKING_REJECT: 'Reject Booking',
  BOOKING_REPLY: 'Reply Booking',
  PR_APPROVE: 'Approve PR',
  PR_REJECT: 'Reject PR',
  PR_ON_HOLD: 'On Hold PR',
  GCPR_APPROVE: 'Approve GC Material PR',
  GCPR_REJECT: 'Reject GC Material PR',
}
